// extracted by mini-css-extract-plugin
export default {"openWebsite":"styles-module__mXDsq","websiteIcon":"styles-module__VDvwE"};